import { DOCUMENT } from '@angular/common';
import { inject, InjectionToken } from '@angular/core';

export const NAVIGATOR = new InjectionToken<Navigator>('Document navigator', {
  factory: () => {
    const { defaultView } = inject(DOCUMENT);
    if (!defaultView) throw new Error('Window is not available');
    return defaultView.navigator;
  },
});
